module.exports = __webpack_public_path__ + "img/mama-2.da4227fd.png";